class Throttler {
    constructor(duration) {
        this._timerId = null;
        this.duration = duration;
        this._fn = null;
    }
    
    executeSoon(fn) {
        this._fn = fn;

        if (!this._timerId) {
            this._startTimer();
        }
    }
    
    debounce(fn) {
        this._fn = fn;
        
        this._clearTimer();
        this._startTimer();
    }
    
    _clearTimer() {
        if (this._timerId) {
            clearTimeout(this._timerId);
            this._timerId = null;
        }
    }
    
    _startTimer() {
        this._timerId = setTimeout(() => this._executeNow(), this.duration);
    }
    
    _executeNow() {
        this._fn();
        this._clearTimer();
    }
}
export default Throttler;
